@if (isLoggedIn) {
  <div class="discresult-view">
    <p-tabView (onChange)="onTabChange($event)">
      <!-- Whenever tabs are reordered or modified so that their indexes change,
      all references to "selectedTab" must be updated to reflect the updated
      indexes (for example, see the "Events" tab below) -->
      <p-tabPanel header="Devices/Maps" headerStyleClass="data-tab" [selected]="true">
        <devices [selected]="selectedTab == DevicesTabIndex"></devices>
      </p-tabPanel>
      <p-tabPanel header="Reports" headerStyleClass="data-tab">
        <reports></reports>
      </p-tabPanel>
      <p-tabPanel header="Events" headerStyleClass="data-tab">
        <events [discResult]="discResult" [selected]="selectedTab == EventsTabIndex"></events>
      </p-tabPanel>
      <p-tabPanel header="Tools" headerStyleClass="config-tab">
        <tools></tools>
      </p-tabPanel>
    </p-tabView>
  </div>
}

